import { useMemo } from 'react';

import { themeObjectToString } from '@atlaskit/tokens/theme-object-to-string';

import { useThemingState } from '@confluence/theming/entry-points/useThemingState.ts';

export const useInitialUrl = (): string => {
	const params = new URLSearchParams(window.location.search);
	const version = params.get('databases-frontend') || undefined;
	const [{ theme }] = useThemingState();

	return useMemo(() => {
		const url = new URL('/databases/standalone', window.location.origin);
		if (version) {
			url.searchParams.set('bifrost-override', version);
		}

		if (theme) {
			url.pathname = `${url.pathname}/${theme.colorMode === 'dark' ? 'index-dark.html' : 'index.html'}`;
			url.searchParams.set('themeState', encodeURIComponent(themeObjectToString(theme)));
		}

		url.searchParams.set('referencing', 'true');
		url.searchParams.set('parentProduct', 'smartLink');

		const finalUrlParts = [url.pathname];
		if (Array.from(url.searchParams).length > 0) {
			finalUrlParts.push(url.searchParams.toString());
		}

		return finalUrlParts.join('?');
	}, [version, theme]);
};
